import React from "react";
import PropTypes from "prop-types";
import { Link } from "@quintype/components";
import { HeroImage } from "../../../atoms/HeroImage";
import { PublishAndReadTime } from "../../../atoms/PublishAndReadTime";
import { Label } from "../../../atoms/Label";
import { getStoryHeadline, getStoryLabel, isExternalStory } from "../../../utils/story";
import Headline from "../../../atoms/Headline";

import "./story-card.m.css";

const CardInfo = ({ story, sectionSlug }) => {
  const label = getStoryLabel(story);
  const headline = getStoryHeadline(story);
  return (
    <div styleName="headline-container">
      {label && <Label story={story} />}
      {headline && <Headline styleName="headline" headline={headline} sectionSlug={sectionSlug} />}
    </div>
  );
};

export const StoryCard = ({ story, showTimeStamp, showReadTime, showImageThumbnail = false, sectionSlug }) => {
  const externalStoryUrl = isExternalStory(story);
  const href = externalStoryUrl ? externalStoryUrl : `/${story?.slug}`;
  const target = externalStoryUrl ? "_blank" : "_self";
  return (
    <div>
      <Link href={href} target={target}>
        <div styleName={`${showImageThumbnail ? "card" : "card-full-width"}`}>
          <div styleName="card-details">
            <CardInfo story={story} sectionSlug={sectionSlug} />
            <PublishAndReadTime story={story} showReadTime={showReadTime} showTimestamp={showTimeStamp} />
          </div>
          {showImageThumbnail && (
            <div>
              <HeroImage story={story} aspectRatio={[[4, 3]]} iconSizes={{ height: 24, width: 24 }} />
            </div>
          )}
        </div>
      </Link>
    </div>
  );
};

StoryCard.propTypes = {
  story: PropTypes.shape({
    slug: PropTypes.string,
  }),
  showTimeStamp: PropTypes.bool,
  showReadTime: PropTypes.bool,
  showImageThumbnail: PropTypes.string,
  sectionSlug: PropTypes.string,
};
